import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function formatDate(isoDate: string) {
  const date = new Date(isoDate)
  return date.toLocaleDateString('pt-BR')
}
export function formatMonthAndYear(isoDate: string) {
  const date = new Date(isoDate)
  return format(date, 'MM/yyyy', { locale: ptBR })
}

export function formatDateForInput(isoDate: string) {
  const date = new Date(isoDate)
  return format(date, 'dd/MM/yyyy')
}

export function formatDateAndTime(isoDate: string) {
  const date = new Date(isoDate)
  return format(date, 'EEEEEE, dd MMM yyyy, HH:mm', { locale: ptBR })
}
